import { DataSchema } from "./models";

export const snowflakeSchemas: DataSchema[] = [
  {
    tableName: "IOT_SENSOR_DATA",
    recordCount: 1250000,
    columns: [
      {
        name: "TIMESTAMP",
        type: "TIMESTAMP",
        description: "Sensor reading timestamp",
        sample: "2024-11-17 10:30:00"
      },
      {
        name: "SENSOR_ID",
        type: "VARCHAR",
        description: "Unique sensor identifier",
        sample: "TEMP-001"
      },
      {
        name: "EQUIPMENT_ID",
        type: "VARCHAR",
        description: "Equipment identifier",
        sample: "PUMP-A-01"
      },
      {
        name: "METRIC_NAME",
        type: "VARCHAR",
        description: "Measured metric",
        sample: "temperature"
      },
      {
        name: "VALUE",
        type: "FLOAT",
        description: "Sensor reading value",
        sample: "85.4"
      },
      {
        name: "UNIT",
        type: "VARCHAR",
        description: "Measurement unit",
        sample: "celsius"
      },
      {
        name: "PLANT_ID",
        type: "VARCHAR",
        description: "Plant location",
        sample: "PLANT-01"
      },
      {
        name: "STATUS",
        type: "VARCHAR",
        description: "Operational status",
        sample: "normal"
      }
    ]
  },
  {
    tableName: "EQUIPMENT_MAINTENANCE",
    recordCount: 45000,
    columns: [
      {
        name: "MAINTENANCE_ID",
        type: "VARCHAR",
        description: "Maintenance record ID",
        sample: "MAINT-2024-001"
      },
      {
        name: "EQUIPMENT_ID",
        type: "VARCHAR",
        description: "Equipment identifier",
        sample: "PUMP-A-01"
      },
      {
        name: "MAINTENANCE_DATE",
        type: "DATE",
        description: "Date of maintenance",
        sample: "2024-10-15"
      },
      {
        name: "MAINTENANCE_TYPE",
        type: "VARCHAR",
        description: "Type of maintenance",
        sample: "preventive"
      },
      {
        name: "ISSUE_FOUND",
        type: "VARCHAR",
        description: "Issues identified",
        sample: "bearing wear"
      },
      {
        name: "DOWNTIME_HOURS",
        type: "FLOAT",
        description: "Equipment downtime",
        sample: "2.5"
      }
    ]
  },
  {
    tableName: "EQUIPMENT_REGISTRY",
    recordCount: 5000,
    columns: [
      {
        name: "EQUIPMENT_ID",
        type: "VARCHAR",
        description: "Equipment identifier",
        sample: "PUMP-A-01"
      },
      {
        name: "EQUIPMENT_NAME",
        type: "VARCHAR",
        description: "Equipment name",
        sample: "Primary Circulation Pump"
      },
      {
        name: "TYPE",
        type: "VARCHAR",
        description: "Equipment type",
        sample: "centrifugal_pump"
      },
      {
        name: "MANUFACTURER",
        type: "VARCHAR",
        description: "Manufacturer",
        sample: "Flowserve"
      },
      {
        name: "INSTALL_DATE",
        type: "DATE",
        description: "Installation date",
        sample: "2020-03-15"
      },
      {
        name: "LOCATION",
        type: "VARCHAR",
        description: "Physical location",
        sample: "Processing Unit A"
      }
    ]
  }
];
